import {ImageVM} from "./ImageVM.model";
/**
 * Created by saeed on 12/29/2016.
 */

export class MarkerVMModel {
  public lat:number;
  public lng:number;
  public label:string;
  public type:MarkerType;

  constructor(_lat:number, _lng:number) {
    this.lat = _lat;
    this.lng = _lng;
  }
}
export enum MarkerType
{

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/MarkerModel.ts